import axios from "axios";
import {
  CITY_CREATE_REQUEST,
  CITY_CREATE_SUCCESS,
  CITY_CREATE_FAIL,
  ALL_CITY_VIEW_REQUEST,
  ALL_CITY_VIEW_SUCCESS,
  ALL_CITY_VIEW_FAIL,
  CITY_UPDATE_REQUEST,
  CITY_UPDATE_SUCCESS,
  CITY_UPDATE_FAIL,
  SERVERADDRESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createCity =
  (obj, callback, setReservationId) => async (dispatch) => {
    dispatch({
      type: CITY_CREATE_REQUEST,
    });
    try {
      const { data } = await axios.post(
        `${SERVERADDRESS}/v1/city/createCity`,
        obj
      );
      dispatch({
        type: CITY_CREATE_SUCCESS,
        payload: data,
      });
      callback && callback(data.id);
    } catch (err) {
      //   notifyFailure(err.response.data.message);
      dispatch({
        type: CITY_CREATE_FAIL,
        payload: err,
      });
    }
  };

export const getAllCities = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_CITY_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/city/getAllCities`,
      obj
    );

    localStorage.setItem("city", JSON.stringify(data));
    // console.log(data, "data");

    dispatch({
      type: ALL_CITY_VIEW_SUCCESS,
      payload: data,
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: ALL_CITY_VIEW_FAIL,
      payload: err,
    });
  }
};

export const updateCityById = (obj, handleSuccess) => async (dispatch) => {
  dispatch({
    type: CITY_UPDATE_REQUEST,
  });
  try {
    const { data } = await axios.patch(
      `${SERVERADDRESS}/v1/city/updateCityById`,
      obj
    );
    handleSuccess();
    // notifySuccess("Updated successfully !");
    dispatch({
      type: CITY_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    // console.log(err);
    // notifyFailure(err?.response?.data?.message);
    dispatch({
      type: CITY_UPDATE_FAIL,
      payload: err,
    });
  }
};
